import { AudioKey, AudioKeyValue } from '../constants/audioKeys';

const SURVIVAL_BGM_LIST: readonly AudioKeyValue[] = [
  AudioKey.BGM_SURVIVAL_1,
  AudioKey.BGM_SURVIVAL_2,
  AudioKey.BGM_SURVIVAL_3,
];

/** BGMと同じ3戦サイクルで切り替わるバトルマップキー */
const SURVIVAL_BG_LIST: readonly string[] = [
  'bg_battle',
  'bg_battle_2',
  'bg_battle_3',
];

/**
 * サバイバルモードの勝利数からBGMキーを返す。
 * 3戦ごとに BGM_SURVIVAL_1 → BGM_SURVIVAL_2 → BGM_SURVIVAL_3 → BGM_SURVIVAL_1 ... とループする。
 */
export function getSurvivalBgmKey(winCount: number): AudioKeyValue {
  const index = Math.floor(winCount / 3) % SURVIVAL_BGM_LIST.length;
  return SURVIVAL_BGM_LIST[((index % SURVIVAL_BGM_LIST.length) + SURVIVAL_BGM_LIST.length) % SURVIVAL_BGM_LIST.length];
}

/**
 * サバイバルモードの勝利数からバトルマップキーを返す。
 * BGMと同じ3戦サイクルで切り替わる。
 */
export function getSurvivalBgKey(winCount: number): string {
  const index = Math.floor(winCount / 3) % SURVIVAL_BG_LIST.length;
  return SURVIVAL_BG_LIST[index];
}
